module.exports = __webpack_public_path__ + "img/payment-2.9b1526b2.png";